function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#ee1c25"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.431,9.173c-.489.157-.759.68-.603,1.17.025.079.061.154.106.223.453.697.255,1.63-.443,2.083-.074.048-.152.09-.234.124-.655.277-.962,1.033-.685,1.688.073.174.184.329.324.455-1.007-.717-1.26-2.105-.569-3.13-.013-.011-.025-.023-.037-.035-.706,1.041-.459,2.454.559,3.193-1.544-.618-2.294-2.371-1.676-3.915.523-1.301,1.873-2.071,3.258-1.856",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.066,11.037l-.919.401.979.216-.665-.75.097.998",
    style: {
      fill: "#ee1c25"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.984,14.561c-.3-.417-.882-.512-1.299-.211-.067.048-.127.105-.179.17-.523.646-1.471.746-2.118.223-.069-.056-.132-.117-.19-.184-.466-.538-1.28-.596-1.817-.13-.142.124-.256.277-.333.449.37-1.179,1.613-1.848,2.801-1.508.007-.016.014-.031.022-.046-1.208-.35-2.476.322-2.864,1.518.111-1.659,1.546-2.915,3.206-2.804,1.398.092,2.547,1.139,2.771,2.523",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.79,13.838l-.665-.75.097.998.508-.864-.919.401",
    style: {
      fill: "#ee1c25"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.417,18.873c.488.161,1.014-.104,1.175-.592.026-.079.041-.16.046-.243.044-.83.752-1.468,1.582-1.425.088.005.176.017.262.037.693.161,1.385-.27,1.546-.963.043-.184.044-.375.005-.559.394,1.172-.219,2.444-1.38,2.867.004.016.007.033.009.05,1.183-.427,1.814-1.715,1.425-2.912.886,1.408.462,3.267-.945,4.153-1.185.746-2.73.575-3.725-.413",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.617,18.168l.979.216-.665-.75.097.998.508-.864",
    style: {
      fill: "#ee1c25"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.267,20.555c.304-.414.214-.997-.2-1.301-.067-.049-.14-.089-.217-.118-.776-.298-1.164-1.169-.866-1.945.032-.082.07-.162.116-.238.367-.609.171-1.401-.438-1.768-.162-.097-.342-.158-.53-.178,1.236-.012,2.256.963,2.3,2.198.017,0,.034.004.05.007-.04-1.257-1.071-2.255-2.329-2.255,1.613-.407,3.25.57,3.657,2.182.344,1.359-.296,2.776-1.543,3.416",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.276,18.245l.508-.864-.919.401.979.216-.665-.75",
    style: {
      fill: "#ee1c25"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.901,11.838c-.002.514.413.932.927.935.083,0,.165-.01.245-.032.803-.215,1.629.262,1.844,1.065.023.085.038.172.046.26.061.709.685,1.234,1.394,1.173.188-.016.37-.073.533-.168-.993.736-2.392.547-3.153-.426-.014.009-.029.017-.045.024.771.993,2.192,1.195,3.209.456-1.065,1.277-2.964,1.449-4.241.384-1.077-.898-1.392-2.42-.759-3.671",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.251,13.712l.097.998.508-.864-.919.401.979.216",
    style: {
      fill: "#ee1c25"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHk);
export default __webpack_public_path__ + "static/media/HK.d17dc0493a3b58c7af8d679095b98b0c.svg";
export { ForwardRef as ReactComponent };